import { Box, SvgIcon, Typography } from '@mui/material';
import LockIcon from 'mdi-react/LockIcon';
import React, { memo } from 'react';
import { I18n } from 'utils/i18n';

const JoinToParticipate = () => (
  <Box
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '15px',
    }}
  >
    <SvgIcon color="secondary">
      <LockIcon />
    </SvgIcon>
    <Typography variant="caption">{I18n.t('Join to participate')}</Typography>
  </Box>
);

export default memo(JoinToParticipate);
